import React, { useCallback, useEffect } from 'react';

import { useDisclose } from 'native-base';

import { useNavigation } from 'hooks/navigation/use-navigation';
import { useRoute } from 'hooks/navigation/use-route';
import { logButtonClick } from 'state/amplitude';
import { ClickEventComponentNames } from 'state/amplitude/constants';

import { LoyaltyPromoCodeCTA } from './loyalty-promo-code-cta';
import { LoyaltyPromoCodeDrawer } from './loyalty-promo-code-drawer';
import { IPromoCodeProps } from './types';

export const LoyaltyPromoCode = ({ onPromoCodeRedeemSuccess }: IPromoCodeProps) => {
  const { params } = useRoute<{ promoCode?: string }>();
  const { isOpen, onOpen, onClose } = useDisclose(!!params.promoCode);
  const { setParams } = useNavigation();
  const onDismiss = useCallback(() => {
    // React router 6 return undefined as string.
    setParams({ ...params, promoCode: '' });
    onClose();
  }, [onClose, setParams, params]);

  const onOpenHandler = () => {
    logButtonClick(
      {
        attributes: {
          component: ClickEventComponentNames.PROMO_CODE_TILE,
          name: 'Have a Promo Code?',
        },
      },
      { logDuplicateClickEvent: true }
    );
    onOpen();
  };

  useEffect(() => {
    if (!isOpen && params.promoCode) {
      // This delay is necessary in order to allow the component to be ready to show the Actionsheet.
      setTimeout(onOpen, 500);
    }
  }, [isOpen, onOpen, params.promoCode]);

  return (
    <>
      <LoyaltyPromoCodeCTA onPress={onOpenHandler} />
      {/* Hack to be able to use React Navigation navigate method from the Actionsheet component */}
      {/* Navigate won't trigger unless Actionsheet is unmounted */}
      {isOpen ? (
        <LoyaltyPromoCodeDrawer
          isOpen={isOpen}
          onDismiss={onDismiss}
          promoCode={params.promoCode?.toString()}
          onPromoCodeRedeemSuccess={onPromoCodeRedeemSuccess}
          onNavigate={onClose}
        />
      ) : null}
    </>
  );
};
